import { useState } from "react";
import { PostCrecaAccountsResponseModel } from "@/features/accounts/creca/services/post-accounts-model";


export const usePostCrecaAccountStates = () => {
  const [crecaAccountId, setCrecaAccountId] = useState("");
  const [crecas, setCrecas] = useState<PostCrecaAccountsResponseModel[]>([]);

  // エラーダイアログ表示フラグ情報
  const [isShowErrorDialog, setIsShowErrorDialog] = useState({
    isError: false,
    errorMessage: "",
    errorCode: "",
  });

  return {
    crecaAccountId,
    setCrecaAccountId,
    crecas,
    setCrecas,
    isShowErrorDialog,
    setIsShowErrorDialog,
  };
};
